import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
    renderField,
    required,
} from "../../../utils/formValidations.js";
import SelectInput from "../../../components/SelectInput";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Modal, ModalHeader, ModalBody } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import { getServerPools, updateServerPool, createServerPool } from "../../../actions/actionServerPool";

const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;

class ServerPoolFormTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentServerPool: {},
            collapseAdvanced: false,
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleSaveSuccess = this.handleSaveSuccess.bind(this);
        this.handleSaveError = this.handleSaveError.bind(this);
    }

    async submitApi(userData) {
        try {
            if (this.props.fromUpdate) {
                userData.server_pool_id = this.state.currentServerPool && this.state.currentServerPool.server_pool_id;
                await this.props.updateServerPool(userData)
            } else {
                await this.props.createServerPool(userData)
            }
            this.handleSaveSuccess()
        } catch (e) {
            this.handleSaveError()
        }
    }

    handleSaveSuccess() {
        const { saveServerPoolError, savedServerPool } = this.props;
        if (saveServerPoolError) {
            NotificationManager.error(saveServerPoolError, "Save Pool", 3000);
        }
        else {
            NotificationManager.success("Pool Saved", "Successfully Saved Pool Config");
            if (this.props.inline) {
                this.props.savedPool(savedServerPool)
            } else {
                this.props.history.push("/update_server_pool/" + savedServerPool.server_pool_id);
            }
        }
    }

    handleSaveError() {
        const { saveServerPoolError } = this.props;
        if (saveServerPoolError) {
            NotificationManager.error(saveServerPoolError, "Save Pool", 3000);
        } else
            NotificationManager.error("Save Pool Failed", "Save Pool Config", 3000);
    }

    cancelButton() {
        if (this.props.inline) {
            this.props.cancelServerPoolModal()
        } else {
            this.props.history.push("/server_pools");
        }
    }


    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.server_pools && nextProps.server_pools.length > 0 && this.props.server_pools !== nextProps.server_pools && this.props.getServerPoolsLoading && this.props.fromUpdate) {
            let currentServerPool = nextProps.server_pools.find(server_pool => server_pool.server_pool_id === this.props.serverPoolId);
            this.setState({ currentServerPool: currentServerPool });
            this.props.initialize({
                server_pool_id: currentServerPool.server_pool_id,
                server_pool_name: currentServerPool.server_pool_name,
                server_pool_type: currentServerPool.server_pool_type
            });
        }
    }

    async componentDidMount() {
        try {
            await this.props.getServerPools()
            if (this.props.server_pools.length > 0 && this.props.serverPoolId !== null) {
                let currentServerPool = this.props.server_pools.find(server_pool => server_pool.server_pool_id === this.props.serverPoolId);
                this.setState({ currentServerPool: currentServerPool });    
            }
        } catch(e) {

        }

    }


    render() {
        const { handleSubmit, serverPoolFormValues } = this.props;
        const { currentServerPool } = this.state;
        let optionsPoolTypes = [
            { value: 'Docker Agent', label: 'Docker Agent' },
            { value: 'Server Pool', label: 'Server' }
        ]
        return (
            <ConditionalWrapper
                condition={this.props.inline}
                wrapper={children => (
                    <Modal isOpen={this.props.serverPoolModal} toggle={this.props.toggleServerPoolModal} backdrop={'static'} centered={false} className="user-modal">
                        <ModalHeader toggle={this.props.toggleServerPoolModal}>Pool
                        </ModalHeader>
                        <ModalBody>
                            {children}
                        </ModalBody>
                    </Modal>

                )}>

                <Form onSubmit={handleSubmit(this.submitApi)}>
                    <CardBody>
                    <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="server_pool_name" className="requiredasterisk">Name </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="text"
                                        name="server_pool_name"
                                        id="server_pool_name"
                                        component={renderField}
                                        validate={required}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="server_pool_name" className="requiredasterisk">Type </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                <Field name="server_pool_type"
                                            selectedValue={serverPoolFormValues && serverPoolFormValues.server_pool_type ? serverPoolFormValues.server_pool_type : ""}
                                            options={optionsPoolTypes}
                                            validate={required}
                                            isUpdateForm={this.props.fromUpdate}
                                            disabled={this.props.fromUpdate}
                                            component={SelectInput}
                                        />

                                </Col>
                            </Row>
                        </FormGroup>
                    </CardBody>
                    <CardFooter>
                        <FormGroup className="form-actions">
                            <Button type="button" size="sm"
                                className="cancel-button"
                                color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                            <Button type="submit"
                                className="submit-button"
                                size="sm" color="primary">Submit</Button>
                        </FormGroup>
                    </CardFooter>
                </Form>
            </ConditionalWrapper>
        );
    }
}

ServerPoolFormTemplate.proptypes = {
    saveServerPool: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let ServerPoolFormWithRouter = withRouter(ServerPoolFormTemplate);


const selector = formValueSelector('ServerPoolForm');

let ServerPoolForm = connect(state => {


    return {
        saveServerPoolError: state.server_pools.saveServerPoolError,
        saveServerPoolLoading: state.server_pools.saveServerPoolLoading,
        savedServerPool: state.server_pools.savedServerPool,
        server_pools: state.server_pools.server_pools,
        getServerPoolsLoading: state.server_pools.getServerPoolsLoading || false,
        serverPoolFormValues: state.form && state.form.ServerPoolForm && state.form.ServerPoolForm.values ? state.form.ServerPoolForm.values : null,
    }
},

    dispatch =>
    ({
        getServerPools: () => dispatch(getServerPools()),
        updateServerPool: (data) => dispatch(updateServerPool(data)),
        createServerPool: (data) => dispatch(createServerPool(data)),
    }))(ServerPoolFormWithRouter);

export default reduxForm({
    form: "ServerPoolForm",
})(ServerPoolForm);